enum CompaniesTableType {
  Agencies = 'agencies',
  Companies = 'companies',
}

export default CompaniesTableType;
